module.exports = __webpack_public_path__ + "img/6类感染.da45f52e.png";